/* The Shopify sheet owns its focus. Suspend the mobile menu's older trap while
   the sheet is open, then restore it when the customer returns to navigation. */
if (!customElements.get('bd-account-entry')) {
  customElements.define('bd-account-entry', class extends HTMLElement {
    connectedCallback() {
      this.account = this.querySelector('shopify-account');
      if (!this.account) return;
      this.onOpen = () => {
        this.dataset.open = 'true';
        document.body.classList.add('bd-account-open');
        if (this.closest('main-menu') && typeof removeTrapFocus === 'function') removeTrapFocus();
      };
      this.onClose = () => {
        this.clearState();
        const menu = this.closest('.main-menu__disclosure.is-open');
        if (menu && typeof trapFocus === 'function') trapFocus(menu, this.account);
      };
      this.account.addEventListener('open', this.onOpen);
      this.account.addEventListener('close', this.onClose);
    }
    clearState() {
      delete this.dataset.open;
      if (!document.querySelector('bd-account-entry[data-open]')) document.body.classList.remove('bd-account-open');
    }
    disconnectedCallback() {
      this.account?.removeEventListener('open', this.onOpen);
      this.account?.removeEventListener('close', this.onClose);
      this.clearState();
    }
  });
}
